import axios, { AxiosInstance } from "axios";

import { Indicacao, Indicacoes } from "../../models/indicacoes";
import {Candidatos} from "../../models/cadastro-qualificado";
import { createCustomInterceptorInstance } from "@fundacao/shared-components/esm/ie/renovacao";

class IndicacoesEspeciaisService {
  private instance: AxiosInstance;

  constructor() {
    this.instance = createCustomInterceptorInstance(process.env.REACT_APP_LEGADO_API);
  }

  async postIndicacaoEspecial(body: Candidatos): Promise<any> {
    const resp = await this.instance
      .post(`/indicacao-especial`, body)
      .catch(err => Promise.reject(err.response?.data));
    return resp.data;
  }

  async deleteIndicacaoEspecial(id : number) : Promise<any>{
    const resp = await this.instance
      .delete(`/indicacao-especial/${id}`)
      .catch(err => Promise.reject(err.response?.data))
    return resp.data;
  }

  async getIndicacoes(bolsaId: number, page: number, cpf = '', nome= '', tipo= '', email= '', telefone= '',
                      curso= ''): Promise<Indicacoes>{
    const resp = await this.instance
        .get(`/indicacoes-especiais/bolsa/${bolsaId}?cpf=${cpf}&nome=${nome}&email=${email}&telefone=${telefone}&curso=${curso}&page=${page}&tipoProduto=${tipo}`)
        .catch(err => Promise.reject(err.response?.data));
    return resp.data;
  }

  async postIndicacaoEspecialExpress(body: Indicacao): Promise<any> {
    const resp  = await this.instance
      .post(`/indicacao-especial-express`, body)
      .catch(err => Promise.reject(err.response?.data));
    return resp.data;
  }

  async putIndicacaoEspecialExpress(body: Indicacao, indicacaoId: number): Promise<any> {
    const resp  = await this.instance
      .put(`/indicacao-especial-express/${indicacaoId}`, body)
      .catch(err => Promise.reject(err.response?.data));
    return resp.data;

  }

  async deleteIndicacaoEspecialExpress(indicacaoId: number): Promise<any>{
    const resp  = await this.instance
      .delete(`${process.env.REACT_APP_LEGADO_API}/indicacao-especial-express/${indicacaoId}`)
      .catch(err => Promise.reject(err.response?.data));
    return resp.data;
  }

}

export default new IndicacoesEspeciaisService();